module.exports = __webpack_public_path__ + "components/app-store/static/s6-8ca9bf9b5f90dc228f57793979c239d6.jpg";